import { useMemo } from 'react'
import GroupMessage from './GroupMessage'
import { formatDate } from '../../utils/date.util'

export default function GroupMessages({ messages }) {
  const groupMessagesByDate = (messages) => {
    const grouped = {}
    messages.forEach((msg) => {
      const date = formatDate(msg.createdAt)
      if (!grouped[date]) grouped[date] = []
      grouped[date].push(msg)
    })
    return Object.entries(grouped).map(([date, msgs], index) => ({
      date,
      messages: msgs.map((m, i) => ({ ...m, _key: `${m.id}-${i}-${index}` })),
    }))
  }

  const groupedMessages = useMemo(() => groupMessagesByDate(messages), [messages])

  return groupedMessages.map(({ date, messages }) => (
    <div key={`group-${date}`}>
      <p className="mx-auto w-fit px-4 py-1 text-center text-xs text-gray-600 mb-4 bg-background shadow rounded-full">
        {date}
      </p>

      {messages.map((msg) => (
        <GroupMessage message={msg} key={msg.id} />
      ))}
    </div>
  ))
}
